import { render, staticRenderFns } from "./NoticeDialog.vue?vue&type=template&id=08b4f388&scoped=true&"
import script from "./NoticeDialog.vue?vue&type=script&lang=js&"
export * from "./NoticeDialog.vue?vue&type=script&lang=js&"
import style0 from "./NoticeDialog.vue?vue&type=style&index=0&id=08b4f388&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b4f388",
  null
  
)

export default component.exports